import { Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { Box } from '@mui/system';
import * as React from 'react';
import { useNavigate, Link } from 'react-router-dom';

import Grid, { QueryOptions } from '../Grid';
import { AppContext } from '../../AppContext';
import { FormatUserTime, useUserTime } from '../../hooks/useUserTime';

const buildColumns = (formatUserTime: FormatUserTime): GridColDef[] => [
  {
    field: 'companyName',
    headerName: 'company name',
    filterable: true,
    sortable: true,
    renderCell: ({row}: any) => (<Link to={`/studios/${row?.id}`}>{row?.companyName}</Link>)
  },
  { field: 'status', width: 150, filterable: true, sortable: true },
  { field: 'country', width: 150, filterable: true, sortable: true },
  { field: 'email', width: 150, filterable: true, sortable: true },
  { field: 'region', width: 150, filterable: true, sortable: true },
  { field: 'size', width: 150, filterable: true, sortable: true },
  { field: 'manager.name', headerName: 'manager', width: 150, filterable: true, sortable: true, valueGetter: (_value, row) => row?.manager?.name},
  { field: 'lastComment', headerName: 'last comment', width: 300, filterable: true, sortable: true, valueGetter: (_value, row) => formatUserTime(row?.lastComment?.date) },
  { field: 'website', width: 150, filterable: true, sortable: true },
];


export default function StudiosPage() {
  const {client, notificationsService, user} = React.useContext(AppContext);
  const navigate = useNavigate();
  const formatUserTime = useUserTime();
  const columns = React.useMemo(() => buildColumns(formatUserTime), [formatUserTime]);

  const fetchData = async (options: QueryOptions) => {
    const result = await client<any, any>({
      event: 'studios.getAll',
      data: options as any
    })

    if (result.success) {
      return result.value
    } else {
      notificationsService.notify({
        severity: 'error',
        message: `Error: ${JSON.stringify(result.errors)}`
      });

      return {data: [], pageInfo: {}}
    }
  };


  return <Box sx={{display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Box sx={{marginBottom: 1}}>
      <Button
        variant="contained"
        onClick={() => navigate('/studios/new')}
      >
        CREATE NEW STUDIO
      </Button>
      {
        user.role === "admin"
        ? (<Button
          variant="contained"
          onClick={() => navigate('/studios/report')}
          sx={{marginLeft: 1}}
        >
          Report
        </Button>)
        : <></>
      }
            {
        user.role === "admin"
        ? (<Button
          variant="contained"
          onClick={() => navigate('/studios/import')}
          sx={{marginLeft: 1}}
        >
          Import
        </Button>)
        : <></>
      }
    </Box>
    <Box sx={{flexGrow: 1}}>
      <Grid
        cacheName={'studios'}
        columns={columns}
        fetchData={fetchData}
        onRowClick={(id) => {}}
        showSearch={true}
      />
    </Box>
  </Box>
}
